<template>
  <DebugConsole v-if="debugMode" />
  <router-view />
</template>

<script>
import { ref, provide } from "vue";
import DebugConsole from "./common/debug-console.vue";

export default {
  name: "main-app",
  setup() {
    const filled = false;
    const channels = ref(["whatsapp", "wechat", /*"email"*/])
    provide("channels", {channels})

    return {
      currentUser: undefined,
    };
  },
  data() {
    let debugMode = false;
    let appVersion = "1.0.2";
    let appTitle = `FWD x PanopticAI ${appVersion}`;

    return {
      vitalSignObject: undefined,
      healthObject: undefined,
      host: location.host,
      appVersion: appVersion,
      appTitle: appTitle,
      debugMode: debugMode,
      debugMessage: "[ Your debug message ]",
      doneLoading: {
        faceDetectionView: false,
        system: true,
        scanning: true,
      },
    };
  },
  mounted() {
    if (this.debugMode) {
      console.log(`%c< ${this.appTitle} > DEBUG MODE`, "color: red");
    } else {
      console.log(`< ${this.appTitle} >`);
    }
  },
  computed: {
    noPassword() {
      return this.host.match(/^localhost:[\d]{1,4}/) || location.href.match(/^.*\/#\/report.*/);
    },
  },
  components: {
    DebugConsole,
  },
};
</script>

<style>
#app {
  font-family: FWDCircular !important;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.border-fwd-dark-green {
  border-color: #183028 !important;
}

.border-fwd-orange {
  border-color: #e87722 !important;
}

.bg-fwd-orange {
  background-color: #e87722;
}

.bg-fwd-orange-50 {
  background-color: #f3bb90;
}

.bg-fwd-orange-20 {
  background-color: #fae4d3;
}

.continue-button {
  border-radius: 4px;
  background: #e87722;
  font-size: 20px;
  width: 229px;
  color: white;
  border: none;
}

.continue-button-clear {
  border-radius: 4px;
  border: 2px solid #e87722;
  background-color: transparent;
  font-size: 20px;
  width: 229px;
  color: #e87722;
}
.input {
  border: 1px solid #dbdfe1;
  border-radius: 4px;
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
  font-size: 31px;
  font-weight: 500;
  padding: 7px;
  width: 100%;
}

.continue-button:disabled {
  opacity: 0.7;
  background-color: #e87722;
  color: white;
  border: none;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.2);
}
.continue-button-clear:disabled {
  opacity: 0.5;
}
.description {
  padding: 80px 123px 115px 123px;
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  border-radius: 0px 0px 36px 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: 90%;
}
.fwd-orange {
  color: #e87722 !important;
}

.fwd-dark-green {
  color: #183028;
}

.fwd-white {
  color: #ffffff;
}

.g-18 {
  gap: 18px;
}

.g-24 {
  gap: 24px;
}

.header {
  position: relative;
  border-radius: 24px 24px 0px 0px;
  padding: 120px 80px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.metrics {
  gap: 20px;
}

.metrics-container {
  gap: 35px;
  padding: 0 42px;
}
.metrics-image {
  width: 50px;
  height: 50px;
}

.metrics-name {
  font-size: 25px;
}
::-webkit-scrollbar {
  display: none;
}
#printable {
  position: absolute;
  left: -10000px;
  top: auto;
  overflow: hidden;
  pointer-events: none;
}
.spinner {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.start-content {
  border-radius: 24px;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-self: center;
}
.start-content-container {
  position: absolute;
  top: 0%;
  padding: 56px 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  height: calc(96vh - 56px);
  margin-top: 56px;
}
.subtitle {
  font-weight: 500;
  font-size: 36px;
  text-align: center;
}
.title {
  font-weight: 600;
  font-size: 56px;
  text-align: center;
}
@media (max-width: 1800px) {
  .input {
    font-size: 25px;
  }
}

@media (max-width: 2000px) {
  .continue-button {
    padding: 10px;
  }
  .continue-button-clear {
    padding: 8px;
  }
  .description {
    font-size: 20px;
    padding: 24px;
    padding-bottom: 48px;
  }
  .header {
    padding: 24px;
  }
  .subtitle {
    font-size: 25px;
  }
  .title {
    font-size: 31px;
  }
}

/* phone */
@media (max-width: 767px) {
  .start-content-container {
    padding: 40px 50px;
  }
  .start-content{
    border-radius: 12px;
  }
  .title {
    font-size: 18px;
  }
  .subtitle {
    font-size: 15px;
  }
  .metrics-image {
    width: 30px;
    height: 30px;
  }
  .metrics-name {
    font-size: 15px !important;
  }
  .metrics-container {
    padding: 0px 15px;
    gap: 15px;
  }
  .continue-button {
    font-size: 14px;
    width: 200px;
  }
  .continue-button-clear {
    font-size: 14px;
    width: 200px;
  }
  .input {
    font-size: 18px;
    font-weight: 500;
    padding: 7px;
    width: 200px;
  }
  .header {
    padding: 15px;
    border-radius: 12px 12px 0px 0px;
  }
  .description {
    padding: 14px;
    padding-bottom: 24px;
    gap: 15px;
    border-radius: 0px 0px 12px 12px;
    font-size: 14px;
  }
  .g-24 {
    gap: 12px;
  }
}

@media screen and (width: 2160px) and (height: 3180) {
  .start-content {
    top: 25%;
    left: 12.5%;
    width: 75%;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
